const base = {
    music: 'https://fmp-api.finesoft.org'
//     music: 'http://localhost:3000'
}

export default base
